import get from "lodash.get";
import { REHYDRATE } from "redux-persist";
import ParkStatisticsActionTypes from "./types";
import ContractActionTypes from "services/contract/types";
import AuthenticationActionTypes from "services/authentication/types";

const initialState = {
  filters: {
    timestamp: Math.round(new Date().getTime() / 1000), // today in seconds
    areaType: [],
  },
  map: {
    initialized: false,
  },
  details: {
    initialized: false,
  },
  general: {
    initialized: false,
  },
  controls: {
    initialized: false,
  },
  dailyAttendance: {
    initialized: false,
  },
  autoRefresh: false,
  initialized: false,
};

const ParkStatisticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      return {
        ...initialState,
        map: {
          ...get(initialState, "map"),
          ...(get(action, "payload.ParkStatistics.map.selectedLayers") && {
            selectedLayers: [
              ...get(action, "payload.ParkStatistics.map.selectedLayers"),
            ],
          }),
        },
      };
    case AuthenticationActionTypes.LOG_OUT:
    case ContractActionTypes.SWITCH_CONTRACT:
      return initialState;
    case ParkStatisticsActionTypes.SET_LOADING:
      return {
        ...state,
        [action.statName]: {
          ...state[action.statName],
          initialized: false,
        },
      };
    case ParkStatisticsActionTypes.SET_AUTO_REFRESH:
      return {
        ...state,
        autoRefresh: action.autoRefresh,
      };
    case ParkStatisticsActionTypes.SET_DETAILS_STATS:
      return {
        ...state,
        details: {
          ...action.stats,
          initialized: true,
        },
      };
    case ParkStatisticsActionTypes.SET_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.key]: action.value,
        },
      };
    case ParkStatisticsActionTypes.SET_FILTERS:
      return {
        ...state,
        filters: action.value,
      };
    case ParkStatisticsActionTypes.SET_GENERAL_STATS:
      return {
        ...state,
        general: {
          ...action.stats,
          initialized: true,
        },
      };
    case ParkStatisticsActionTypes.SET_MAP_INFOS:
      return {
        ...state,
        map: {
          ...action.map,
          initialized: true,
        },
      };
    case ParkStatisticsActionTypes.SET_SELECTED_LAYERS:
      return {
        ...state,
        map: {
          ...state.map,
          selectedLayers: action.layers,
        },
      };
    case ParkStatisticsActionTypes.SET_CONTROLS_STATS:
      return {
        ...state,
        controls: {
          ...action.stats,
          initialized: true,
        },
      };
    case ParkStatisticsActionTypes.SET_DAILY_ATTENDANCE_STATS:
      return {
        ...state,
        dailyAttendance: {
          ...state.dailyAttendance,
          ...action.stats,
          initialized: true,
        },
      };
    case ParkStatisticsActionTypes.SET_INITIALIZED:
      return {
        ...state,
        initialized: action.value,
      };
    case ParkStatisticsActionTypes.SET_ATTENDANCE_TIME_LIMIT:
      return {
        ...state,
        dailyAttendance: {
          ...state.dailyAttendance,
          timeLimit: action.limitTime,
        },
      };
    default:
      return state;
  }
};

export default ParkStatisticsReducer;
